class SeoTools
{

    constructor(element) 
    {
        if (typeof element != 'object' ||
            typeof element.data('title') === 'undefined' ||
            typeof element.data('title-tab') === 'undefined' ||
            typeof element.data('description') === 'undefined' ||
            typeof element.data('keywords') === 'undefined' ||
            typeof element.data('slug-prefix') === 'undefined' ||
            typeof element.data('language') === 'undefined') {
                
            console.log('SeoTools: data incomplete');
            return;
        }

        this.element = element;

        this.elements = {
            title: $(this.element.data('title')),
            title_tab: $(this.element.data('title-tab')),
            description: $(this.element.data('description')),
            keywords: $(this.element.data('keywords')),
            language: $(this.element.data('language'))
        }

        this.score = 0;
        this.notices = [];

        this.calculate();

        this.events();
    }
    
    events() {

        let self = this;

        $(document).on('keyup', [
            self.element.data('title'),
            self.element.data('title-tab'),
            self.element.data('description'),
            self.element.data('keywords')
        ].join(', '), function() {

            self.calculate();
        });
    }

    calculate() {

        this.score = 0
        
        //words in content
        //content length (words and charCount)
        // gehele content en delen ervan (paragrafen) in rest van seopages content doorzoeken en vergelijken IF dubbel melde!!! DUBBELE CONTENT
        //content headings check 
            //goed oplopend, 
            //geen overgeslagen worden, 
            //zitten er uberhaupt headings in
            //dezelfde titels?

            // use Google\Cloud\Translate\TranslateClient;

            // /** Uncomment and populate these variables in your code */
            // // $text = 'The text whose language to detect.  This will be detected as en.';
            
            // $translate = new TranslateClient();
            // $result = $translate->detectLanguage($text);
            // print("Language code: $result[languageCode]\n");
            // print("Confidence: $result[confidence]\n");

        this.calculateTitle();
        this.calculateTitleTab();
        this.calculateSlug();
        this.calculateDescription();
        this.calculateKeywords();
        this.setScore();

        this.update();

        this.element.find('.percentage').html((this.score * 10)+"%");
    }

    update() {

        let slug = this.getSlug(true);
        if (slug === false) {
            slug = '-';
        }

        this.element.find('.title').html(this.elements.title.val());
        this.element.find('.slug').html(slug);
        this.element.find('.description').html(this.elements.description.val().substring(0,160));
    }

    setScore() {

        this.element.find('.percentage')
            .removeClass('percentage-50')
            .removeClass('percentage-75')
            .removeClass('percentage-100');

        if (this.score <= 5) {
            this.element.find('.percentage').addClass('percentage-50');
        }

        if (this.score > 5 && this.score <= 7.5) {
            this.element.find('.percentage').addClass('percentage-75');
        }

        if (this.score > 7.5) {
            this.element.find('.percentage').addClass('percentage-100');
        }

    }

    calculateTitle() {

        if (this.elements.title.val().length < 3) {
            this.notices.push('TITLE.SHORT');
        }
        
        if (this.elements.title.val().length >= 3 && 
            this.elements.title.val().length <= 70) {
            this.score += 2;
        }
        
        if (this.elements.title.val().length > 70) {
            this.score += 1;
            this.notices.push('TITLE.LONG');
        }
    }

    calculateTitleTab() {
        
        if (this.elements.title.val().length < 3) {
            return;
        }

        if (this.elements.title_tab.val().length < 3) {
            this.notices.push('TITLETAB.SHORT');
        }

        if (this.elements.title_tab.val().length >= 3 && this.elements.title_tab.val().length <= 40) {
            this.score += 0.5;
            this.notices.push('TITLETAB.SHORT');
        }

        if (this.elements.title_tab.val().indexOf(this.elements.title.val()) > -1) {
            this.score += 0.5;
        } else {
            this.notices.push('TITLETAB.TITLE_NOT_INCLUDED');
        }

        if (this.elements.title_tab.val().length >= 40) {
            this.notices.push('TITLETAB.LONG');
        }
    }

    calculateSlug() {

        let slug = this.getSlug();

        if (slug === false) {
            return;
        }

        if (slug.length < 71) {
            this.score += 2;
        } else {
            this.score += 1;
            this.notices.push('SLUG.LONG');
        } 
    }

    calculateDescription() {

        let description = this.elements.description.val(),
            wordCount = description.split(' ').length;

        if (wordCount < 5) {
            this.notices.push('DESCRIPTION.TOO_FEW_WORDS');
        }

        if (description.length > 280) {
            this.notices.push('DESCRIPTION.TOO_LONG');
        } else {

            if (wordCount >= 5 && wordCount < 10) {
                this.score += 1;
                this.notices.push('DESCRIPTION.FEW_WORDS');
            }

            if (wordCount >= 10 && wordCount < 15) {
                this.score += 2;
            // this.notices.push('DESCRIPTION.FEW_WORDS');
            }

            if (wordCount >= 15 && wordCount < 25) {
                this.score += 3;
            }

            if (wordCount >= 25) {
                this.score += 1;
                this.notices.push('DESCRIPTION.TOO_MANY_WORDS');
            }
        }
    }

    calculateKeywords() {

        let wordCount = this.elements.keywords.val().split(' ').length;

        if (wordCount < 3) {
            this.notices.push('KEYWORDS.TOO_FEW_WORDS');
        }

        if (wordCount >= 3 && wordCount < 6) {
            this.score += 1;
            this.notices.push('KEYWORDS.FEW_WORDS');
        }

        if (wordCount >= 5 && wordCount <= 10) {
            this.score += 2;
        }

        if (wordCount > 10) {
            this.score += 1;
            this.notices.push('KEYWORDS.TOO_MANY_WORDS');
        }

        



        this.score += 1;

    }

    getSlug(includeDomain = false) {

        if (this.elements.title.val() < 3) {
            return false;
        }

        let slug = this.slugify(this.elements.title.val());
        if (this.element.data('slug-prefix') != '') {
            slug = (this.element.data('slug-prefix')+"/"+slug).replace('//', '/');
        }

        return includeDomain
            ? this.element.data('domain')+"/"+slug
            : slug;
    }

    slugify(url) {

        let from = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;',
            to = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------',
            i, l;
      
        for (l = from.length; i < l ; i++) {
            url = url.replace(from.charAt(i), to.charAt(i));
        }
      
        return url
            .toLowerCase()
            .replace(/\s+/gi, '-')
            .replace(/(\s+|\-+)/gi, '-')
            .replace(/^\-/g, '')
            .replace(/\-$/g, '')
            .replace(/[^\w-]+/g,'')
            .split(' ').join('-');      
    }
}


